import WeaponType from "../../enums/WeaponType";
import Game from "../Game";
import GameCore from "../GameCore";
import BaseWeapon from "./BaseWeapon";
import { BulletGroup } from "./BulletGroup";
import HitVFXType from "../../enums/HitVFXType";
import StoneAuraBullet from "./StoneAuraBullet";
import WEAPONS from "../../consts/WEAPONS";

export default class StoneAuraWeapon extends BaseWeapon {
  cooldown: number = 0;
  stones: StoneAuraBullet[] = [];
  anglesIncrement: number = 0;
  radius: number = 100;

  constructor(bulletType: WeaponType, isNewWeapon: boolean = true) {
    super(bulletType, isNewWeapon);

    const weaponData = WEAPONS[WeaponType.STONEAURA][0];

    // To compensate cooldown of COOLDOWN powerup that we've taken
    this.cooldown = weaponData.cooldown ?? 0;

    Game.Core.Player.cooldown += this.cooldown;

    this.createStones();
  }

  createStones() {
    // Clear any existing stones
    this.clearStones();

    // Create new stones based on amount
    for (let i = 0; i < this.PAmount; i++) {
      const angle = (i / this.PAmount) * Math.PI * 2;
      const x = Game.Core.Player.x + Math.cos(angle) * this.radius * this.PArea;
      const y = Game.Core.Player.y + Math.sin(angle) * this.radius * this.PArea;

      // Use the bullet pool system to create stones
      const stone = this.FireOneBullet(x, y, i, null) as StoneAuraBullet;
      stone.setData("angle", angle);
      stone.setData("angleSpeed", 0.01);

      this.stones.push(stone);
    }
  }

  clearStones() {
    for (const stone of this.stones) {
      stone.DeSpawn();
    }
    this.stones = [];
  }

  Update() {
    if (this.stones.length !== this.PAmount) {
      this.createStones();
    }

    // Update stone positions to orbit around player
    for (let i = 0; i < this.stones.length; i++) {
      const stone = this.stones[i];

      // Skip inactive stones
      if (!stone.active) continue;

      // Update angle
      let angle = stone.getData("angle");
      const angleSpeed = stone.getData("angleSpeed") * this.PSpeed;
      angle += angleSpeed;
      stone.setData("angle", angle);

      // Calculate position
      const x = Game.Core.Player.x + Math.cos(angle) * this.radius * this.PArea;
      const y = Game.Core.Player.y + Math.sin(angle) * this.radius * this.PArea;

      // Set position
      stone.setPosition(x, y);

      // Spin the stone itself
      stone.angle += 2;
    }
  }

  CleanUp() {
    super.CleanUp();
    this.clearStones();
  }

  Fire() {
    // For the stone aura, we manage stones in Update instead
    // Return false to indicate we're handling firing manually
    return false;
  }

  LevelUp() {
    const oldAmount = this.PAmount;
    const result = super.LevelUp();

    // If amount has changed, recreate stones
    if (oldAmount !== this.PAmount) {
      this.createStones();
    }

    return result;
  }
}
